// What a job or work order Save sends: only the fields the person changed, plus original_values,
// what each of those fields held when they opened it. The server then refuses (409) to undo a
// change someone else made to the same field meanwhile, and leaves fields nobody touched alone.

const isBlank = (value) =>
  value === null || value === undefined || value === false ||
  (typeof value === 'string' && value.trim() === '') ||
  (Array.isArray(value) && value.length === 0);

const normalize = (value, numeric) => {
  if (isBlank(value)) return '';
  if (Array.isArray(value)) return [...value].sort().join(',');
  if (numeric && !isNaN(Number(value))) return String(Number(value));
  return String(value).trim();
};

export const sameValue = (a, b, numeric = false) => normalize(a, numeric) === normalize(b, numeric);

// { changes, originals } for the fields that differ between edited and original
export const changedFields = (edited, original, fields, numericFields = []) => {
  const changes = {};
  const originals = {};
  fields.forEach((field) => {
    if (!sameValue(edited[field], original[field], numericFields.includes(field))) {
      changes[field] = edited[field];
      originals[field] = original[field] ?? null;
    }
  });
  return { changes, originals };
};

// A field's value as the conflict dialog shows it
export const displayValue = (value) => {
  if (isBlank(value)) return value === false ? 'No' : '(blank)';
  if (value === true) return 'Yes';
  if (Array.isArray(value)) return value.join(', ');
  const text = String(value);
  return text.length > 120 ? `${text.slice(0, 117)}...` : text;
};
